import React, {useState} from 'react';
import {Button, Card, Col, Form, Row, Spinner} from 'react-bootstrap';
import PersonAdd from "@mui/icons-material/PersonAddRounded";
import Delete from "@mui/icons-material/DeleteRounded";
import PropTypes from "prop-types";
import {getTenantErrorMessage, tenantsApi} from '../services/tenantsApi';
import {Dropdown} from '../../../shared/ui/Dropdown';

const getId = (val) => val?.id || val;

const MembersSection = ({tenant, path, isOwner}) => {
  const [newMemberEmail, setNewMemberEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("viewers");
  const [memberLoading, setMemberLoading] = useState(false);

  const handleAddMember = async (e) => {
    e.preventDefault();
    if (!newMemberEmail) return;
    setMemberLoading(true);
    const result = await tenantsApi.addTenantMember({
      tenantPath: path, email: newMemberEmail, role: selectedRole
    });

    if (!result.ok) {
      alert(getTenantErrorMessage(result.error, 'Failed to add member.'));
    } else {
      setNewMemberEmail("");
    }

    setMemberLoading(false);
  };

  const handleRemoveMember = async (role, val) => {
    const email = getId(val);
    if (!globalThis.confirm(`Remove user ${email} from ${role}?`)) return;
    setMemberLoading(true);
    const result = await tenantsApi.removeTenantMember({
      tenantPath: path, email, role
    });

    if (!result.ok) {
      alert(getTenantErrorMessage(result.error, 'Failed to remove member.'));
    }

    setMemberLoading(false);
  };

  return (<Row>
    <Col md={12}>
      <Card className='island'>
        <Card.Header>
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Members</h5>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            {['owners', 'admins', 'viewers'].map(role => (<Col md={4} key={role} className="mb-3">
              <h6 className="text-uppercase text-muted small fw-bold">{role}</h6>
              <div>
                {tenant[role]?.map(val => {
                  const id = getId(val);
                  return (<div key={id} className="d-flex justify-content-between align-items-center py-2"
                               style={{borderBottom: '1px solid var(--border-color)'}}>
                    <span className="text-truncate" title={id}>{id}</span>
                    {isOwner && (<Button variant="link" className="text-danger p-0"
                                         onClick={() => handleRemoveMember(role, val)} disabled={memberLoading}>
                      <Delete fontSize="small"/>
                    </Button>)}
                  </div>);
                })}
                {(!tenant[role] || tenant[role].length === 0) && (
                  <div className="text-muted small">No members</div>)}
              </div>
            </Col>))}
          </Row>

          {isOwner && (<div className="mt-4 p-3 island">
            <h6>Add Member</h6>
            <Form onSubmit={handleAddMember} className="d-flex gap-2">
              <Form.Control
                placeholder="User Email"
                value={newMemberEmail}
                onChange={e => setNewMemberEmail(e.target.value)}
                disabled={memberLoading}
              />
              <Dropdown
                options={[
                  {value: 'owners', label: 'Owner'},
                  {value: 'admins', label: 'Admin'},
                  {value: 'viewers', label: 'Viewer'},
                ]}
                value={selectedRole}
                onChange={(val) => setSelectedRole(val)}
                disabled={memberLoading}
                style={{width: '150px'}}
              />
              <Button type="submit" variant="primary" disabled={memberLoading}>
                {memberLoading ? <Spinner size="sm" animation="border"/> : <PersonAdd/>}
              </Button>
            </Form>
          </div>)}
        </Card.Body>
      </Card>
    </Col>
  </Row>);
};

MembersSection.propTypes = {
  tenant: PropTypes.shape({
    owners: PropTypes.arrayOf(PropTypes.string),
    admins: PropTypes.arrayOf(PropTypes.string),
    viewers: PropTypes.arrayOf(PropTypes.string)
  }).isRequired, isOwner: PropTypes.bool.isRequired, path: PropTypes.string.isRequired
};

export default MembersSection;
